<template>
  <div class="page-shell">
    <PageBanner
      eyebrow="PRODUCT INTRODUCTION"
      background-image="/page/products-banner.jpg"
      :title="pageTitle"
      :subtitle="product.summary"
    />

    <section class="section">
      <div class="container detail-shell">
        <router-link class="back-link" :to="backPath">
          <span aria-hidden="true">&lt;</span>
          {{ $pick(backText) }}
        </router-link>

        <div class="detail-layout">
          <figure v-reveal class="product-figure">
            <img :src="product.src" :alt="$pick(product.title)" />
          </figure>

          <article v-reveal class="detail-copy">
            <div class="breadcrumb">{{ $pick(breadcrumb) }}</div>
            <p class="eyebrow">PRODUCT DETAIL</p>
            <h1>{{ $pick(product.title) }}</h1>
            <p class="summary">{{ $pick(product.summary) }}</p>
            <p class="description">{{ $pick(product.description) }}</p>

            <div class="spec-list">
              <div v-for="spec in product.specs" :key="$pick(spec)" class="spec-item">
                {{ $pick(spec) }}
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PageBanner from "../../components/common/PageBanner.vue";
import { getProductDetailBySlug } from "../../data/site";

export default {
  name: "ProductItemDetailPage",
  components: { PageBanner },
  computed: {
    product() {
      return getProductDetailBySlug(this.$route.params.slug) || {
        title: { "zh-CN": "产品详情", "en-US": "Product Detail" },
        summary: { "zh-CN": "暂未找到该产品信息。", "en-US": "Product information was not found." },
        description: { "zh-CN": "请返回产品中心重新选择产品。", "en-US": "Please return to the product center and choose again." },
        specs: [],
        src: "/page/products-banner.jpg",
        categoryPath: "/products"
      };
    },
    pageTitle() {
      return this.product.title;
    },
    backPath() {
      return this.product.categoryPath || "/products";
    },
    backText() {
      return { "zh-CN": "返回产品分类", "en-US": "Back to Category" };
    },
    breadcrumb() {
      return {
        "zh-CN": "首页 > 产品中心 > " + this.$pick(this.product.categoryTitle) + " > " + this.$pick(this.product.title),
        "en-US": "Home > Products > " + this.$pick(this.product.categoryTitle) + " > " + this.$pick(this.product.title)
      };
    }
  }
};
</script>

<style scoped>
.detail-shell {
  display: grid;
  gap: 24px;
}

.back-link {
  display: inline-flex;
  width: fit-content;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  color: var(--brand-blue);
  background: #eef5fb;
  border: 1px solid rgba(18, 95, 166, 0.18);
  font-weight: 700;
}

.back-link:hover {
  background: var(--brand-blue);
  color: #fff;
}

.detail-layout {
  display: grid;
  grid-template-columns: minmax(320px, 0.95fr) minmax(360px, 1.05fr);
  gap: 34px;
  align-items: stretch;
}

.product-figure {
  margin: 0;
  padding: 18px;
  background: #fff;
  border: 1px solid var(--line);
  box-shadow: var(--shadow);
}

.product-figure img {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 420px;
  object-fit: contain;
  background: #f3f6fa;
}

.detail-copy {
  padding: 34px;
  background: #fff;
  border: 1px solid var(--line);
  box-shadow: var(--shadow);
}

.breadcrumb {
  margin-bottom: 18px;
  color: #8a94a3;
  font-size: 13px;
  line-height: 1.7;
}

.eyebrow {
  margin: 0 0 10px;
  color: var(--brand-blue);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.detail-copy h1 {
  margin: 0;
  color: var(--brand-blue-deep);
  font-size: clamp(30px, 4vw, 46px);
  line-height: 1.16;
}

.summary {
  margin: 18px 0 0;
  color: #243449;
  font-size: 19px;
  font-weight: 700;
  line-height: 1.75;
}

.description {
  margin: 18px 0 0;
  color: #596678;
  line-height: 1.9;
}

.spec-list {
  display: grid;
  gap: 12px;
  margin-top: 26px;
}

.spec-item {
  padding: 15px 16px;
  color: #314257;
  background: #f5f8fc;
  border-left: 3px solid var(--brand-blue);
  line-height: 1.7;
}

@media (max-width: 900px) {
  .detail-layout {
    grid-template-columns: 1fr;
  }

  .product-figure img {
    min-height: 300px;
  }
}

@media (max-width: 560px) {
  .detail-copy,
  .product-figure {
    padding: 18px;
  }

  .detail-copy h1 {
    font-size: 28px;
  }

  .summary {
    font-size: 17px;
  }
}
</style>
